import {
  getErrorToPrint as getMobileLinesErrorToPrint,
} from './mobileLines';
import {
  getErrorToPrint as getActivateMobileLineErrorToPrint,
} from './activateMobileLine';
import {
  getErrorToPrint as getXboxGamePassErrorToPrint,
} from './xboxGamePass';
import {
  getErrorToPrint as getActivateXboxGamePassBonusErrorToPrint,
} from './activateXboxGamePassBonus';
import {
  getErrorToPrint as getInternetErrorToPrint,
} from './internet';
import {
  getErrorToPrint as getDevicesErrorToPrint,
} from './devices';
import {
  getErrorToPrint as getR2RErrorToPrint,
} from './r2r';
import {
  getErrorToPrint as getPackErrorToPrint,
} from './pack';
import {
  getErrorToPrint as getTVErrorToPrint,
} from './tv';
import {
  getErrorToPrint as getFTTRErrorToPrint,
} from './fttr';
import {
  getErrorToPrint as getBonusErrorToPrint,
} from './bonus';
import {
  getErrorToPrint as getEquipmentErrorToPrint,
} from './equipment';
import {
  getErrorToPrint as getManualErrorToPrint,
} from './manual';
import {
  getErrorToPrint as getEmployeesErrorToPrint,
} from './employees';
import {
  getErrorToPrint as getPrepaidErrorToPrint,
} from './prepaid';
import {
  getErrorToPrint as getMultiSimErrorToPrint,
} from './multiSim';
import {
  getErrorToPrint as getCarErrorToPrint,
} from './car';
import {
  getErrorToPrint as getProtectionErrorToPrint,
} from './protection';
import {
  getErrorToPrint as getESimErrorToPrint,
} from './eSim';
import {
  getErrorToPrint as getR2RRenewalErrorToPrint,
} from './r2rRenewal';
import {
  getErrorToPrint as getSubscriptionsErrorToPrint,
} from './subscriptions';
import {
  getErrorToPrint as getChangeOTTModalityErrorToPrint,
} from './changeOTTModality';
import {
  getErrorToPrint as getDuoErrorToPrint,
} from './duo';
import {
  getErrorToPrint as getBillinToPrint,
} from './billin';
import {
  getErrorToPrint as getSpeedChangeErrorToPrint,
} from './speedChange';
import {
  getErrorToPrint as getR2rAutoRenewalErrorToPrint,
} from './r2rAutoRenewal';
import {
  getErrorToPrint as getPackR2RErrorToPrint,
} from './packR2R';
import {
  getErrorToPrint as getMovistarPlusErrorToPrint,
} from './movistarPlus';
import { FLOW_TYPES } from '../../../flowDefinition/flowTypes';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    [FLOW_TYPES.MOBILE_LINES]: getMobileLinesErrorToPrint(goToC2C),
    [FLOW_TYPES.ACTIVATE_MOBILE_LINE]: getActivateMobileLineErrorToPrint(goToC2C),
    [FLOW_TYPES.XBOX_GAME_PASS]: getXboxGamePassErrorToPrint(goToC2C),
    [FLOW_TYPES.ACTIVATE_XBOX_GAME_PASS_BONUS]: getActivateXboxGamePassBonusErrorToPrint(goToC2C),
    [FLOW_TYPES.INTERNET]: getInternetErrorToPrint(goToC2C),
    [FLOW_TYPES.DEVICES]: getDevicesErrorToPrint(goToC2C),
    [FLOW_TYPES.R2R]: getR2RErrorToPrint(goToC2C),
    [FLOW_TYPES.R2R_2]: getR2RErrorToPrint(goToC2C),
    [FLOW_TYPES.PACK]: getPackErrorToPrint(goToC2C),
    [FLOW_TYPES.TV]: getTVErrorToPrint(goToC2C),
    [FLOW_TYPES.FTTR]: getFTTRErrorToPrint(goToC2C),
    [FLOW_TYPES.BONUS]: getBonusErrorToPrint(goToC2C),
    [FLOW_TYPES.EQUIPMENT]: getEquipmentErrorToPrint(goToC2C),
    [FLOW_TYPES.MANUAL]: getManualErrorToPrint(goToC2C),
    [FLOW_TYPES.EMPLOYEES]: getEmployeesErrorToPrint(goToC2C),
    [FLOW_TYPES.PREPAID]: getPrepaidErrorToPrint(goToC2C),
    [FLOW_TYPES.MULTI_SIM]: getMultiSimErrorToPrint(goToC2C),
    [FLOW_TYPES.CAR]: getCarErrorToPrint(goToC2C),
    [FLOW_TYPES.PROTECTION]: getProtectionErrorToPrint(goToC2C),
    [FLOW_TYPES.E_SIM]: getESimErrorToPrint(goToC2C),
    [FLOW_TYPES.R2R_RENEWAL]: getR2RRenewalErrorToPrint(goToC2C),
    [FLOW_TYPES.SUBSCRIPTIONS]: getSubscriptionsErrorToPrint(goToC2C),
    [FLOW_TYPES.CHANGE_OTT_MODALITY]: getChangeOTTModalityErrorToPrint(goToC2C),
    [FLOW_TYPES.DUO]: getDuoErrorToPrint(goToC2C),
    [FLOW_TYPES.BILLIN]: getBillinToPrint(goToC2C),
    [FLOW_TYPES.SPEED_CHANGE]: getSpeedChangeErrorToPrint(goToC2C),
    [FLOW_TYPES.R2R_AUTO_RENEWAL]: getR2rAutoRenewalErrorToPrint(goToC2C),
    [FLOW_TYPES.PACK_R2R]: getPackR2RErrorToPrint(goToC2C),
    [FLOW_TYPES.MOVISTAR_PLUS]: getMovistarPlusErrorToPrint(goToC2C),
  }
};
